import CONFIG from '../../config';
import { Injectable } from '@angular/core';
//import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Router } from '@angular/router';

import { LoadingService } from '../loading-spinner/loading.service';

import { Observable } from 'rxjs/Observable';
import { catchError } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class AuthService {
    public isLoggedIn: boolean;
    public CustomerID: string = localStorage.getItem('CustomerID') || sessionStorage.getItem('CustomerID');
    public CustomerType: string = localStorage.getItem('CustomerType') || sessionStorage.getItem('CustomerType');
    public token: string = localStorage.getItem('token') || sessionStorage.getItem('token');
    public OperatingAcc:string=localStorage.getItem('OperatingAcc') || sessionStorage.getItem('OperatingAcc');
    constructor(
        private _http: HttpClient,
        private _router: Router,
        private _loadingService: LoadingService
    ) {}

  login(loginData): Observable<any> {
        this._loadingService.show();
        const body = JSON.stringify(loginData);
    //     const headers = new Headers({
    //         'Content-Type': 'application/json',
    //         'Accept': 'application/json'
    //     });
    //     const options = new RequestOptions({ headers: headers });
    //     return this._http.post(CONFIG.loginApiUrlBase, body, options)
    //         .map(response => {
    //             return response.json();
    //         })
    //         .catch(this.handleError)
    //         .finally(() => {
    //             this._loadingService.hide();
    //         });
    // }
    let headers = new HttpHeaders({
        'Content-Type': 'application/json',
        "X-Frame-Options": "SAMEORIGIN",
        "X-Content-Type-Options": "nosniff",
        "X-Xss-Protection": "1; mode=block",
        "Host":"",
        "Server":"",
        "Content-Security-Policy": "script-src https: 'unsafe-inline' 'unsafe-eval';style-src https: 'unsafe-inline' 'unsafe-eval';img-src https: data:;font-src https: data:;", 
        'Accept': 'application/json'
     });
     let options = {
        headers: headers
     }

    // const headers = new Headers({
    //     'Content-Type': 'application/json',
    //     'Accept': 'application/json'
    // });
    // const options = new RequestOptions({ headers: headers });
    return this._http.post(CONFIG.loginApiUrlBase, body, options)
    .pipe(
        catchError(this.handleError)
    );
        // .map(response => {
        //     return response;
        // })
        // .catch(this.handleError)
        // .finally(() => {
        //     this._loadingService.hide();
        // });
}


 
    logout() {
        this._loadingService.show();
        this.isLoggedIn = false;        
        this._http.get(CONFIG.loginApiUrlBase)
            .subscribe(response => {
                this._loadingService.hide();

                //if the user had the 'remember me' flag enabled, session info stored in localStorage
                if (localStorage.getItem('token') !== null) {
                    localStorage.removeItem('Expires/Max-Age');
                    localStorage.removeItem('CustomerID');
                    localStorage.removeItem('token');
                    localStorage.removeItem('CustomerID');
                    localStorage.removeItem('CustomerType');
                    
                }

                //if the user did not have the 'remember me' flag enabled, session info stored in sessionStorage
                if (sessionStorage.getItem('token') !== null) {
                    localStorage.removeItem('CustomerID');
                    sessionStorage.removeItem('token');
                    localStorage.removeItem('CustomerID');
                      localStorage.removeItem('CustomerType');
                }

                //remove locally cached identity variables
                this.token = null;
                this.isLoggedIn = false;
                this.CustomerID = null;

                this._router.navigate(['/']);
            },
            error => {
                this.handleError(error);
            },
            () => {
                this._loadingService.hide();
            });
    }

    /*
    Utility error handler function for server errors
    */
    private handleError(error) {
        const errMsg = error.message || 'Server error';
        return Observable.throw(error);
    }
}